var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import ___default from "lodash";
import "../models/index.js";
import { AudienceFilterDataType } from "../models/expapiv2/AudienceFilterModels.js";
import { compareIgnoreCase } from "@ane/core/lib/utils/CommonStringUtils";
import { OperatorCategory, OperatorConstants } from "../models/TrafficFilterModel.js";
const convertFilterPolicy = (policies) => {
  const result = {};
  ___default.each(policies, (policy) => {
    var _a;
    result[policy.audienceFilterId] = {
      DisplayName: policy.displayName,
      Description: policy.description,
      DisplayOrder: 0,
      DataType: policy.dataType,
      OperatorCategory: operatorCategoryBasedOnDataType(policy.dataType),
      IsRequired: policy.isRequired,
      Values: (_a = policy.audienceFilterAllowedValues) == null ? void 0 : _a.reduce((a, v) => __spreadProps(__spreadValues({}, a), { [v.allowedValueId]: v.displayName }), {}),
      EnabledOverrideTypes: [],
      IsHidden: policy.isArchived
    };
  });
  return result;
};
const convertFilterPolicyV2 = (policies) => {
  const result = {};
  ___default.each(policies, (policy) => {
    var _a;
    result[policy.id] = {
      DisplayName: policy.displayName,
      Description: policy.description,
      DisplayOrder: 0,
      DataType: policy.dataType,
      OperatorCategory: operatorCategoryBasedOnDataType(policy.dataType),
      IsRequired: policy.isRequired,
      Values: (_a = policy.audienceFilterAllowedValues) == null ? void 0 : _a.reduce((a, v) => __spreadProps(__spreadValues({}, a), { [v.allowedValueId]: v.displayName }), {}),
      EnabledOverrideTypes: [],
      IsHidden: policy.isArchived
    };
  });
  return result;
};
const operatorCategoryBasedOnDataType = (dataType) => {
  if (dataType === AudienceFilterDataType.Boolean) {
    return OperatorCategory[OperatorCategory.InOnly];
  } else if (dataType === AudienceFilterDataType.Integer || dataType === AudienceFilterDataType.Version) {
    return OperatorCategory[OperatorCategory.AllOperators];
  }
  return OperatorCategory[OperatorCategory.InAndNotIn];
};
const removeNullValues = (values) => {
  return ___default.filter(values, (v) => v !== null && v !== void 0);
};
const generateFilterExpression = (audienceFilters, filterPolicies) => {
  const result = [];
  const policyByFilterKey = ___default.keyBy(filterPolicies, (policy) => policy.audienceFilterId);
  ___default.each(Object.keys(audienceFilters), (variant) => {
    const variantDetails = audienceFilters[variant];
    if (!!policyByFilterKey[variant]) {
      const orExpression = generateOrExpressions(variantDetails, policyByFilterKey[variant]);
      if (!!(orExpression == null ? void 0 : orExpression.trim())) {
        result.push(orExpression);
      }
    }
  });
  return result.join("; ");
};
const generateOrExpressions = (variantDetails, policy) => {
  var _a;
  const result = [];
  ___default.each((_a = variantDetails == null ? void 0 : variantDetails.currentValue) == null ? void 0 : _a.clause, (orClauses) => {
    let andExpression = generateAndExpressions(orClauses, policy);
    if (!!(andExpression == null ? void 0 : andExpression.trim())) {
      if ((andExpression.match(/AND/g) || []).length >= 1) {
        andExpression = `(${andExpression})`;
      }
      result.push(andExpression);
    }
  });
  return result.join(" OR ");
};
const generateAndExpressions = (orClauseDict, policy) => {
  const result = [];
  ___default.each(orClauseDict.selectedBaseOperators, (selectedOperator) => {
    const operatorValue = generateOperatorValue(orClauseDict.trafficFilterRule, selectedOperator, policy);
    if (!!(operatorValue == null ? void 0 : operatorValue.trim())) {
      result.push(operatorValue);
    }
  });
  return result.join(" AND ");
};
const generateOperatorValue = (operatorValuesDict, selectedOperator, policy) => {
  const valueString = generateValues(operatorValuesDict, selectedOperator, policy);
  const result = `${policy.audienceFilterId} ${generateOperator(selectedOperator)} ${valueString}`;
  return !!valueString ? result : "";
};
const generateOperator = (selectedOperator) => {
  switch (selectedOperator) {
    case OperatorConstants.In: {
      return "IN";
    }
    case OperatorConstants.NotIn: {
      return "NOTIN";
    }
    case OperatorConstants.GreaterThan: {
      return ">";
    }
    case OperatorConstants.GreaterThanOrEqual: {
      return ">=";
    }
    case OperatorConstants.LessThan: {
      return "<";
    }
    case OperatorConstants.LessThanOrEqual: {
      return "<=";
    }
    default: {
      return "IN";
    }
  }
};
const generateValues = (operatorValuesDict, selectedOperator, policy) => {
  const result = [];
  ___default.each(operatorValuesDict[selectedOperator], (value) => {
    if (policy.dataType === AudienceFilterDataType.String) {
      var escapedStringValue = value.replace('"', '\\"');
      result.push(`"${escapedStringValue}"`);
    } else if (policy.dataType === AudienceFilterDataType.Boolean) {
      result.push(compareIgnoreCase(value, "true") ? "True" : "False");
    } else {
      result.push(value);
    }
  });
  return isGroupOperator(selectedOperator) && result.length > 0 ? `(${result.join(", ")})` : result.join(", ");
};
const generateValuesUnified = (operatorValuesDict, selectedOperator, policy) => {
  const result = [];
  ___default.each(operatorValuesDict[selectedOperator], (value) => {
    if (policy.dataType === AudienceFilterDataType.String) {
      var stringVal = value;
      var escapedStringValue = stringVal.replace('"', '\\"');
      result.push(`"${escapedStringValue}"`);
    } else if (policy.dataType === AudienceFilterDataType.Boolean) {
      var boolVal = value;
      result.push(boolVal);
    } else {
      result.push(value);
    }
  });
  return isGroupOperator(selectedOperator) && result.length > 0 ? `(${result.join(", ")})` : result.join(", ");
};
const isGroupOperator = (selectedOperator) => {
  return selectedOperator.toLocaleUpperCase() === OperatorConstants.In.toLocaleUpperCase() || selectedOperator.toLocaleUpperCase() === OperatorConstants.NotIn.toLocaleUpperCase();
};
const audienceFilterToTrafficFilterClause = (audienceFilter) => {
  if (audienceFilter.type === "AND") {
    return {
      clause: [andValuesToRuleDictionary(audienceFilter)]
    };
  } else if (audienceFilter.type === "Base") {
    return {
      clause: [baseValuesToRuleDictionary(audienceFilter)]
    };
  }
  const audienceFilterClause = audienceFilter.clause;
  const value1 = audienceFilterToTrafficFilterClause(audienceFilterClause.firstOrFilter);
  const value2 = audienceFilterToTrafficFilterClause(audienceFilterClause.secondOrFilter);
  return {
    clause: [...value1.clause, ...value2.clause]
  };
};
const andValuesToRuleDictionary = (audienceFilter) => {
  if (audienceFilter.type === "AND") {
    const audienceFilterClause = audienceFilter.clause;
    const baseValue1 = baseValuesToRuleDictionary(audienceFilterClause.firstAndFilter);
    const baseValue2 = baseValuesToRuleDictionary(audienceFilterClause.secondAndFilter);
    return {
      trafficFilterRule: __spreadValues(__spreadValues({}, baseValue1.trafficFilterRule), baseValue2.trafficFilterRule),
      currentSelectedOperator: "Between",
      selectedBaseOperators: [baseValue1.currentSelectedOperator, baseValue2.currentSelectedOperator]
    };
  }
  return {
    trafficFilterRule: {},
    currentSelectedOperator: "",
    selectedBaseOperators: []
  };
};
const baseValuesToRuleDictionary = (audienceFilter) => {
  if (audienceFilter.type === "Base") {
    const audienceFilterClause = audienceFilter.clause;
    const trafficFilterOperator = toTrafficFilterOperator(audienceFilterClause.operator);
    return {
      trafficFilterRule: {
        [trafficFilterOperator]: audienceFilterClause.type === "SingleValue" ? [audienceFilterClause.values.toString()] : [...audienceFilterClause.values.map((v) => v.toString())]
      },
      currentSelectedOperator: trafficFilterOperator,
      selectedBaseOperators: [trafficFilterOperator]
    };
  }
  return {
    trafficFilterRule: {},
    currentSelectedOperator: "",
    selectedBaseOperators: []
  };
};
const toTrafficFilterOperator = (operator) => {
  switch (operator) {
    case "IN":
    case "In":
      return OperatorConstants.In;
    case "NOTIN":
    case "NotIn":
      return OperatorConstants.NotIn;
    case ">=":
    case "GE":
      return OperatorConstants.GreaterThanOrEqual;
    case ">":
    case "GT":
      return OperatorConstants.GreaterThan;
    case "<=":
    case "LE":
      return OperatorConstants.LessThanOrEqual;
    case "<":
    case "LT":
      return OperatorConstants.LessThan;
    default:
      return OperatorConstants.In;
  }
};
export {
  andValuesToRuleDictionary,
  audienceFilterToTrafficFilterClause,
  baseValuesToRuleDictionary,
  convertFilterPolicy,
  convertFilterPolicyV2,
  generateAndExpressions,
  generateFilterExpression,
  generateOperator,
  generateOperatorValue,
  generateOrExpressions,
  generateValues,
  generateValuesUnified,
  isGroupOperator,
  operatorCategoryBasedOnDataType,
  removeNullValues,
  toTrafficFilterOperator
};
//# sourceMappingURL=AudienceFilter.utils.js.map
